// imports
import axios from 'axios'

// export authMiddleware
export const authMiddleware = (store, router) => {
  // beforeEach
  router.beforeEach((to, from, next) => {
    const requiredAuth = to.matched.some(record => record.meta.requiredAuth)
    const currentUser = store.getters['auth/currentUser']

    if (requiredAuth && !currentUser) {
      next({
        name: 'auth.login'
      })
    } else if (to.path === '/login' && currentUser) {
      next({
        name: 'dashboard'
      })
    } else {
      next()
    }
  })

  // axios interceptors
  axios.interceptors.response.use(response => response, error => {
    if (error.response.status === 401) {
      store.dispatch('auth/logout')
      .then(() => {
        router.push({
          name: 'auth.login'
        })
      })
    }
    return Promise.reject(error)
  })

  // setAuthorization
  const authUser = store.getters['auth/currentUser']
  if (authUser) {
    setAuthorization(authUser.token)
  }
}

// export setAuthorization
export const setAuthorization = (token) => {
  axios.defaults.headers.common['Authorization'] = `Bearer ${token}`
}
